import React, { memo } from "react";
import useServiceWorkerWrapper from "./index.hooks";
import { Snackbar } from "@material-ui/core";
import { AppButton } from "../index";

type ServiceWorkerWrapperProps = {};

const ServiceWorkerWrapper = ({}: ServiceWorkerWrapperProps) => {
  const {
    styles,
    classes,
    anchorOrigin,
    t,
    atomicStyles,
    showReload,
    reloadPage,
  } = useServiceWorkerWrapper();

  return (
    <Snackbar
      open={showReload}
      message={t("\u00C8 disponibile una nuova versione!")}
      onClick={reloadPage}
      anchorOrigin={anchorOrigin}
      action={
        <AppButton
          variant="contained"
          color="secondary"
          size="small"
          onClick={reloadPage}
        >
          {t("Aggiorna")}
        </AppButton>
      }
    />
  );
};

export default memo(ServiceWorkerWrapper);
